import * as React from 'react';

const { useReducer } = React;

export type CB<T> = (updatedState: T) => void;
export type SetState<T> = (newState: Partial<T>, cb?: CB<T>) => void;

function genericSetState<T>(state: T, action: Partial<T>): T {
  return {
    ...state,
    ...action,
  };
}

function useGenericState<T>(initialState: T): [T, SetState<T>] {
  type U = T & { cb?: CB<T> };
  // Fixed: Use standard useReducer with proper reducer signature
  const [state, setState] = useReducer(genericSetState<U>, {
    ...initialState,
    cb: () => {},
  } as unknown as U);

  React.useEffect(() => {
    if (state.cb && typeof state.cb === 'function') {
      state.cb(state);
    }
  }, [state.cb]);

  const setStateLocal: SetState<T> = (newState, cb) => {
    setState({
      ...newState,
      cb,
    } as Partial<U>);
  };

  return [state as T, setStateLocal];
}

export { useGenericState };